module.exports = __webpack_public_path__ + "img/cat.0d0064f2.png";